export default __webpack_public_path__ + "static/media/cs-a018-9.28fdbe1f.svg";